import React, { useState, useEffect } from 'react';
import PerfectScrollBar from 'react-perfect-scrollbar';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Button, Modal, Select } from 'antd';
import * as qs from 'query-string';
import * as Yup from 'yup';

import './styles.scss';

import icNavLeft from './../../../../assets/images/navigation/ic-chevron-left.svg';
import { connect } from 'react-redux';
import {
  changeMillStatus,
  changeLCVStatus,
  getMillDetails,
  getMills,
  deactivateMill,
  changeDirectInvoiceStatus,
  updateAllocatedSM as updateAllocatedSMAction,
  updateOdaStatus,
} from 'store/actions/UserActions';
import { DeactivateMillModal } from './EditMillModal';
import Sections from './MillDetailSections';
import { getLocofastUsers as getLocofastUsersAction } from 'store/actions/AuthActions';
import StatusToggler from 'components/UI/Toggler/StatusToggler';
import { flash } from 'store/actions/CommonActions';
import FieldInput from 'components/AccountSettings/TopQualities/FieldInput';
import { Formik } from 'formik';
import { UPTO_TWO_DECIMAL_REGEX } from 'components/AccountSettings/Customers/CustomerDetailsPage/AnnualTurnover/config';
import { CATEGORY_TYPES } from '../constants';
import { QUERY_TYPE, USER_ROLE_TYPE } from 'constants/Global';

const EditMill = ({
  initialValues = {},
  mills,
  getMills,
  getMillDetails,
  millDetails,
  match,
  changeMillStatus,
  changeLCVStatus,
  deactivateMill,
  changeDirectInvoiceStatus,
  getLocofastUsers,
  updateAllocatedSM,
  lfUsers,
  showErrorMessage,
  updateODA,
  ...restProps
}) => {
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [editSM, setEditSM] = useState('');
  const [viewSM, setViewSM] = useState(false);
  const [editSMListModal, setEditSMListModal] = useState(false);
  const [initialSMs, setInitialSMs] = useState([]);
  const [initialSMsInt, setInitialSMsInt] = useState([]);
  const [updatedSMs, setUpdatedSMs] = useState([]);
  const [updatedSMsInt, setUpdatedSMsInt] = useState([]);
  const [addedSMs, setAddedSMs] = useState([]);
  const [SMDetails, setSMDetails] = useState({});
  const [contactPerson, setContactPerson] = useState('');
  const [millData, setMillData] = useState({});
  const [isNotFoundError, setIsNotFoundError] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCommissionSlabVisible, setIsCommissionSlabVisible] = useState(false);
  const id = match.params.id;
  const { Option } = Select;
  const queryParams = qs.parse(restProps.location.search);
  const invoiceStatus = millData?.isDirectInvoicing;
  const { supplierCommission } = millData || {};
  const cottonValue = supplierCommission?.[0]?.percentage;
  const rayonValue = supplierCommission?.[1]?.percentage;
  const validationSchema = Yup.object().shape({
    cottonPercentage: Yup.number()
      .test('maxDigitsAfterDecimal', 'Maximum decimal alowed is 2', (number) =>
        UPTO_TWO_DECIMAL_REGEX.test(number),
      )
      .max(20, 'Commission cannot be greater than 20%'),
    rayonPercentage: Yup.number()
      .test('maxDigitsAfterDecimal', 'Maximum decimal alowed is 2', (number) =>
        UPTO_TWO_DECIMAL_REGEX.test(number),
      )
      .max(20, 'Commission cannot be greater than 20%'),
  });
  const handleActivate = () => {
    if (millData?.isActive === 'Y') {
      setDeactivateModal(!deactivateModal);
    } else {
      deactivateMill({
        supplierId: millData?.supplierId.toString(),
        newStatus: 'activate',
      });
    }
  };
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCloseCommisionSlab = () => {
    setIsModalVisible(false);
  };
  const handleAddCommissionSlab = (values) => {
    changeDirectInvoiceStatus({
      supplierId: millData?.supplierId.toString(),
      params: {
        isDirectInvoicing: 1,
        supplierCommission: [
          {
            categoryId: CATEGORY_TYPES.Cotton,
            percentage: values.cottonPercentage.toString(),
          },
          {
            categoryId: CATEGORY_TYPES.Rayon,
            percentage: values.rayonPercentage.toString(),
          },
        ],
      },
      invoiceStatus,
    });
    setIsModalVisible(false);
    if (isCommissionSlabVisible) {
      setIsCommissionSlabVisible(false);
    }
  };
  const handleStatusChange = (isOnline) => {
    const status = isOnline ? 1 : 0;
    const supplierId = millData?.supplierId;
    changeMillStatus({ supplierId, status });
  };

  const handleEditSM = (data) => {
    setSMDetails(data);
    setEditSM(data.id);
  };

  const handleUpdateSM = (data) => {
    const fabricCategoryId = SMDetails?.category[0]?.id;
    const managerId = SMDetails?.id;
    const supplierId = millData?.supplierId;
    updateAllocatedSM({ fabricCategoryId, managerId, supplierId });
    setEditSM('');
  };

  const handleLCVChange = (status, annualTurnover) => {
    const isCertified = status ? 1 : 0;
    const supplierId = millData?.supplierId;

    if (annualTurnover || !status) {
      changeLCVStatus({ supplierId, isCertified });
    } else {
      showErrorMessage('Please upload annual turnover details');
    }
  };
  const handleInvoiceChange = () => {
    const invoiceStatus = millData?.isDirectInvoicing;
    if (!invoiceStatus) {
      showModal();
    } else {
      changeDirectInvoiceStatus({
        supplierId: millData?.supplierId.toString(),
        params: { isDirectInvoicing: 0 },
        invoiceStatus,
      });
    }
  };

  const handleSMChange = (categoryId, selectedSMId, userRoleType, queryType) => {
    if (+queryType === QUERY_TYPE.DOMESTIC) {
      setUpdatedSMs((prev) => {
        const existing = prev.find(
          (item) => item.categoryId === categoryId && +item.queryType === +queryType,
        );
        if (existing) {
          return prev.map((item) =>
            item.categoryId === categoryId &&
            +item.userRoleType === +userRoleType &&
            +item.queryType === +queryType
              ? { ...item, selectedSM: selectedSMId, userRoleType, queryType }
              : item,
          );
        } else {
          return [...prev, { categoryId, selectedSM: selectedSMId, userRoleType, queryType }];
        }
      });
    } else if (+queryType === QUERY_TYPE.INTERNATIONAL) {
      setUpdatedSMsInt((prev) => {
        const existing = prev.find(
          (item) => item.categoryId === categoryId && +item.queryType === +queryType,
        );
        if (existing) {
          return prev.map((item) =>
            item.categoryId === categoryId &&
            +item.userRoleType === +userRoleType &&
            +item.queryType === +queryType
              ? { ...item, selectedSM: selectedSMId, userRoleType, queryType }
              : item,
          );
        } else {
          return [...prev, { categoryId, selectedSM: selectedSMId, userRoleType, queryType }];
        }
      });
    }
  };

  const handleSMAddition = (categoryId, selectedSMId, userRoleType, queryType) => {
    setAddedSMs((prev) => {
      const existing = prev.find(
        (item) =>
          item.categoryId === categoryId &&
          +item.userRoleType === +userRoleType &&
          +item.queryType === +queryType,
      );
      if (existing) {
        return prev.map((item) =>
          item.categoryId === categoryId
            ? { ...item, selectedSM: selectedSMId, userRoleType, queryType }
            : item,
        );
      } else {
        return [...prev, { categoryId, selectedSM: selectedSMId, userRoleType, queryType }];
      }
    });
  };

  const areSMsEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    const sorted1 = [...arr1].sort((a, b) => a.categoryId - b.categoryId);
    const sorted2 = [...arr2].sort((a, b) => a.categoryId - b.categoryId);

    return sorted1.every(
      (item, index) =>
        item.categoryId === sorted2[index].categoryId &&
        item.selectedSM === sorted2[index].selectedSM,
    );
  };

  const handleModalClose = () => {
    setEditSMListModal(false);
    setUpdatedSMs([]);
    setUpdatedSMsInt([]);
    setAddedSMs([]);
  };

  const fabricTypeMap = {
    'Domestic SMs': 1,
    'International SMs': 2,
    Both: 3,
  };

  const handleBulkSMUpdate = () => {
    const supplierId = millData?.supplierId;
    const changedPairs = [...updatedSMs, ...updatedSMsInt, ...addedSMs]
      .filter((updated) => {
        const initial = [...initialSMs, ...initialSMsInt].find(
          (i) =>
            i.categoryId === updated.categoryId &&
            +i.userRoleType === +updated.userRoleType &&
            +i.queryType === +updated.queryType,
        );
        return initial?.selectedSM !== updated.selectedSM;
      })
      .map((updated) => ({
        fabricCategoryId: updated.categoryId,
        managerId: updated.selectedSM,
        supplierId: String(supplierId),
        userRoleType: updated.userRoleType,
        queryType: updated.queryType,
      }));

    updateAllocatedSM({
      changedSupplierManagers: changedPairs,
      supplierId,
    });
    setEditSMListModal(false);
  };

  useEffect(() => {
    if (editSMListModal && millData?.supplierManager) {
      const domesticInitial = [];
      const internationalInitial = [];

      millData.supplierManager.forEach((sm) => {
        sm.fabricCategory.forEach((cat) => {
          const smObj = {
            categoryId: cat.id,
            selectedSM: sm.id,
            userRoleType: sm.userRoleType,
            queryType: sm.queryType,
          };

          if (sm.queryType === QUERY_TYPE.DOMESTIC) {
            domesticInitial.push(smObj);
          } else if (sm.queryType === QUERY_TYPE.INTERNATIONAL) {
            internationalInitial.push(smObj);
          }
        });
      });

      setInitialSMs(domesticInitial);
      setUpdatedSMs(domesticInitial);
      setInitialSMsInt(internationalInitial);
      setUpdatedSMsInt(internationalInitial);
    }
  }, [editSMListModal]);

  useEffect(() => {
    if (millDetails?.data.id) {
      setIsNotFoundError('');
      setContactPerson(millDetails?.data.firstName + ' ' + (millDetails?.data.lastName || ''));
      setMillData(millDetails?.data);
    }
    if (millDetails?.error) {
      setIsNotFoundError(millDetails?.error);
    }
  }, [millDetails]);

  useEffect(() => {
    setMillData({});
    getMillDetails(id);
    getLocofastUsers(['13', '16']); // TODO : add constant

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { annualTurnover = null } = millData;
  return (
    <div className="factory-add-edit-container">
      <PerfectScrollBar style={{ maxHeight: '900px' }}>
        <div className="factory-container">
          <header>
            <div className="navContainer">
              <div className="flex-column">
                <div className="mill-heading">Mill Details</div>
                <div className="leftNavBtns">
                  <Link
                    className="nav-left"
                    to={`../${
                      queryParams.search
                        ? `?search=${queryParams.search}&page=${queryParams.page}`
                        : ''
                    }`}>
                    <img src={icNavLeft} alt="nav-left" />
                  </Link>
                  <div className="mill-heading-details">
                    <h4>{millData?.companyName}</h4>
                    <p>{millData?.alias}</p>

                    {millData?.deactivationReason && (
                      <p className="red-message">
                        Deactivation Reason: {millData?.deactivationReason}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="rightNavBtns">
                <div className="flex items-center space-x-4">
                  <Button type="link" onClick={() => setViewSM(true)} className="view-sm-button">
                    View mapped SM
                  </Button>
                  <span className="listing-bar">|</span>
                  <Button
                    type="link"
                    onClick={() => setEditSMListModal(true)}
                    className="view-sm-button">
                    Edit mapped SM
                  </Button>
                </div>

                <Modal
                  title={<div className="sm-modal-heading">Mapped SM list</div>}
                  visible={viewSM}
                  onCancel={() => setViewSM(false)}
                  footer={null}
                  width={450}
                  className="edit-supplier-modal">
                  {millData?.supplierManager?.length ? (
                    <>
                      {/* Domestic SMs */}
                      <h4 className="group-heading">
                        <b>Domestic SMs</b>
                      </h4>
                      {/* <div className="sm-section-title">Domestic SMs</div> */}
                      {millData.supplierManager
                        .filter(
                          (sm) =>
                            sm.queryType === QUERY_TYPE.DOMESTIC ||
                            sm.queryType === QUERY_TYPE.BOTH,
                        )
                        .map((sm, idx) =>
                          sm.fabricCategory.map((fabricCategory, catIdx) => (
                            <div className="sm-row" key={`domestic-${sm.id}-${catIdx}`}>
                              <div className="sm-category">
                                {fabricCategory.category}{' '}
                                {+sm.userRoleType === USER_ROLE_TYPE.OPERATIONAL_MANAGER
                                  ? 'Ops'
                                  : 'RM'}
                              </div>
                              <div className="sm-name">{sm.name}</div>
                            </div>
                          )),
                        )}
                      {/* International SMs */}
                      <h4 className="group-heading">
                        <b>International SMs</b>
                      </h4>
                      {millData.supplierManager
                        .filter(
                          (sm) =>
                            sm.queryType === QUERY_TYPE.INTERNATIONAL ||
                            sm.queryType === QUERY_TYPE.BOTH,
                        )
                        .map((sm, idx) =>
                          sm.fabricCategory.map((fabricCategory, catIdx) => (
                            <div className="sm-row" key={`international-${sm.id}-${catIdx}`}>
                              <div className="sm-category">
                                {fabricCategory.category}{' '}
                                {+sm.userRoleType === USER_ROLE_TYPE.OPERATIONAL_MANAGER
                                  ? 'Ops'
                                  : 'RM'}
                              </div>
                              <div className="sm-name">{sm.name}</div>
                            </div>
                          )),
                        )}
                    </>
                  ) : (
                    <p>No supplier managers mapped.</p>
                  )}
                </Modal>

                <Modal
                  title={<div className="sm-modal-heading">Select new supplier manager</div>}
                  open={editSMListModal}
                  onCancel={handleModalClose}
                  footer={[
                    <Button key="cancel" onClick={handleModalClose} className="close-btn-custom">
                      Close
                    </Button>,
                    <Button
                      key="update"
                      type="primary"
                      className="update-btn"
                      onClick={handleBulkSMUpdate}
                      // disabled={areSMsEqual(
                      //   [...initialSMs, ...initialSMsInt],
                      //   [...updatedSMs, ...updatedSMsInt, ...addedSMs],
                      // )}
                      >
                      Update
                    </Button>,
                  ]}
                  width={550}
                  className="edit-supplier-modal">
                  {(() => {
                    const OPERATIONAL_MANAGER = +USER_ROLE_TYPE.OPERATIONAL_MANAGER;
                    const RELATIONSHIP_MANAGER = +USER_ROLE_TYPE.RELATIONSHIP_MANAGER;

                    // Get all categories from millData
                    const allCategories =
                      millData?.supplierManager?.flatMap((sm) =>
                        (sm.fabricCategory || []).map((cat) => ({
                          categoryId: cat.id,
                          categoryName: cat.category.trim(),
                          queryType: sm.queryType,
                        })),
                      ) || [];

                    // Deduplicate and sort category list
                    const uniqueCategories = Array.from(
                      new Map(allCategories.map((cat) => [cat.categoryId, cat])).values(),
                    ).sort((a, b) => a.categoryName.localeCompare(b.categoryName));

                    // Map of existing managers for each category
                    const roleMapByCategory = new Map(); // { categoryId: { RM: userId, OPS: userId, smType: 'Domestic'|'International' } }

                    millData?.supplierManager?.forEach((sm) => {
                      const smType = sm.queryType === 2 ? 'International' : 'Domestic'; // Treat 1 & 3 as Domestic
                      (sm.fabricCategory || []).forEach((cat) => {
                        const existing = roleMapByCategory.get(cat.id) || { smType };
                        const role =
                          +sm.userRoleType === OPERATIONAL_MANAGER
                            ? 'OPS'
                            : +sm.userRoleType === RELATIONSHIP_MANAGER
                            ? 'RM'
                            : null;
                        if (role) {
                          existing[role] = sm.id;
                          roleMapByCategory.set(cat.id, existing);
                        } else {
                          roleMapByCategory.set(cat.id, existing);
                        }
                      });
                    });

                    // Always prepare both Domestic and International groups
                    const groupedCategories = {
                      'Domestic SMs': uniqueCategories,
                      'International SMs': uniqueCategories,
                    };

                    // Render both groups
                    return Object.entries(groupedCategories).flatMap(
                      ([groupTitle, categories], groupIndex) => {
                        const groupSections = [
                          <React.Fragment key={`${groupTitle}-wrapper`}>
                            {groupIndex > 0 && <hr className="section-divider" />}
                            <h4 className="group-heading">
                              <b>{groupTitle}</b>
                            </h4>
                          </React.Fragment>,
                        ];

                        categories.forEach(({ categoryId, categoryName, queryType }) => {
                          const categoryRoles = roleMapByCategory.get(categoryId) || {};

                          // RM Section
                          const rmSelectedValue = [...updatedSMs, ...updatedSMsInt].find(
                            (item) =>
                              +item.categoryId === categoryId &&
                              +item.userRoleType === RELATIONSHIP_MANAGER &&
                              +item.queryType === fabricTypeMap[groupTitle],
                          )?.selectedSM;

                          const rmChangeHandler = categoryRoles.RM
                            ? handleSMChange
                            : handleSMAddition;

                          groupSections.push(
                            <div key={`${groupTitle}-${categoryId}-RM`} className="sm-edit-block">
                              <h3 className="category-heading">Category: {categoryName} RM</h3>
                              <Select
                                placeholder="Select supplier manager"
                                optionFilterProp="children"
                                showSearch
                                value={rmSelectedValue || undefined}
                                onChange={(value) =>
                                  rmChangeHandler(
                                    categoryId,
                                    value,
                                    RELATIONSHIP_MANAGER,
                                    fabricTypeMap[groupTitle],
                                  )
                                }
                                className="dropdown-select"
                                style={{ width: '100%' }}>
                                {lfUsers?.map((user) => (
                                  <Select.Option key={user.id} value={user.id}>
                                    {`${user.firstName} ${user.lastName}`}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>,
                          );

                          // OPS Section
                          const opsSelectedValue = [...updatedSMs, ...updatedSMsInt].find(
                            (item) =>
                              +item.categoryId === categoryId &&
                              +item.userRoleType === OPERATIONAL_MANAGER &&
                              +item.queryType === fabricTypeMap[groupTitle],
                          )?.selectedSM;

                          const opsChangeHandler = categoryRoles.OPS
                            ? handleSMChange
                            : handleSMAddition;

                          groupSections.push(
                            <div key={`${groupTitle}-${categoryId}-OPS`} className="sm-edit-block">
                              <h3 className="category-heading">Category: {categoryName} Ops</h3>
                              <Select
                                placeholder="Select supplier manager"
                                optionFilterProp="children"
                                showSearch
                                value={opsSelectedValue || undefined}
                                onChange={(value) =>
                                  opsChangeHandler(
                                    categoryId,
                                    value,
                                    OPERATIONAL_MANAGER,
                                    fabricTypeMap[groupTitle],
                                  )
                                }
                                className="dropdown-select"
                                style={{ width: '100%' }}>
                                {lfUsers?.map((user) => (
                                  <Select.Option key={user.id} value={user.id}>
                                    {`${user.firstName} ${user.lastName}`}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>,
                          );
                        });

                        return groupSections;
                      },
                    );
                  })()}
                </Modal>

                <div className="millDetailsToggles">
                  <StatusToggler
                    label={'Mill Status'}
                    condition={millData?.isOnline}
                    onFalseLabel={'Offline'}
                    onTrueLabel={'Online'}
                    onChange={handleStatusChange}
                  />
                  <StatusToggler
                    label={'Locofast Certified Vendor'}
                    condition={millData?.isCertified}
                    onFalseLabel={'No'}
                    onTrueLabel={'Yes'}
                    onChange={(status) => handleLCVChange(status, annualTurnover)}
                  />
                  <StatusToggler
                    label={'Status'}
                    condition={millData?.isActive === 'Y'}
                    onFalseLabel={'Deactivate'}
                    onTrueLabel={'Activate'}
                    onChange={() => handleActivate()}
                  />
                </div>
                <div className="flex">
                  {invoiceStatus ? (
                    <div
                      className="millEditBtn mr-6"
                      onClick={() => setIsCommissionSlabVisible(true)}>
                      View commission slab
                    </div>
                  ) : (
                    ''
                  )}
                  <StatusToggler
                    label={'Direct Invoicing'}
                    condition={Boolean(millData?.isDirectInvoicing)}
                    onFalseLabel={'No'}
                    onTrueLabel={'Yes'}
                    onChange={handleInvoiceChange}
                  />
                </div>
              </div>
            </div>
          </header>

          {isNotFoundError || !millData?.id ? (
            <section className="details-card details-error">
              <div className="error">Mill doesn't exist !!</div>
            </section>
          ) : (
            <>
              <DeactivateMillModal
                visible={deactivateModal}
                toggle={setDeactivateModal}
                data={millData}
                action={deactivateMill}
              />
              <Sections millData={millData} contactPerson={contactPerson} updateODA={updateODA} />
            </>
          )}
        </div>
      </PerfectScrollBar>
      <div>
        <Modal
          title={'Select New Supplier Manager'}
          visible={editSM}
          // onOk={handleSubmit}
          onCancel={() => setEditSM('')}
          okButtonProps={{ disabled: true }}
          cancelButtonProps={{ disabled: false }}
          footer={[
            <Button key="back" onClick={() => setEditSM('')}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              role="submit"
              onClick={handleUpdateSM}
              disabled={editSM == SMDetails?.id}>
              Update
            </Button>,
          ]}>
          <>
            <h3>
              Category:{' '}
              {SMDetails?.category?.map((data) => (
                <span>{data.category + ' '}</span>
              ))}
            </h3>
            <Select
              placeholder="Select SM"
              optionFilterProp="children"
              showSearch={true}
              value={SMDetails.id}
              onChange={(e) => setSMDetails({ ...SMDetails, id: e })}
              className="dropdown-select">
              {lfUsers?.length &&
                lfUsers?.map((user) => (
                  <Option key={user.id} value={user.id}>
                    {`${user.firstName} ${user.lastName}`}
                  </Option>
                ))}
            </Select>
          </>
        </Modal>
        <Modal
          title={`${invoiceStatus ? 'Edit' : 'Add'} commission slab`}
          visible={isModalVisible}
          onCancel={handleCloseCommisionSlab}
          className="supplier-modal"
          destroyOnClose
          footer={null}>
          <Formik
            enableReinitialize
            validationSchema={validationSchema}
            initialValues={
              invoiceStatus
                ? {
                    cottonPercentage: cottonValue,
                    rayonPercentage: rayonValue,
                  }
                : { cottonPercentage: '', rayonPercentage: '' }
            }
            onSubmit={(values) => {}}>
            {({ errors, dirty, values }) => {
              const isButtonDisabled = !dirty || (dirty && Object.keys(errors).length > 0);
              return (
                <>
                  <div>
                    <FieldInput
                      isRequired
                      name="cottonPercentage"
                      label="Greige Cotton"
                      placeholder="Enter Cotton percentage"
                      type="number"
                      isUnit="%"
                    />
                    <div className="mt-8">
                      <FieldInput
                        isRequired
                        name="rayonPercentage"
                        label="Greige Rayon"
                        placeholder="Enter Rayon percentage"
                        type="number"
                        isUnit="%"
                      />
                    </div>
                  </div>
                  <div className="footer">
                    <Button key="back" onClick={handleCloseCommisionSlab} className="clear">
                      Close
                    </Button>
                    <Button
                      key="submit"
                      type="primary"
                      role="submit"
                      className={`apply ${isButtonDisabled && 'disabledButton'}`}
                      onClick={() => handleAddCommissionSlab(values)}
                      disabled={isButtonDisabled}>
                      {invoiceStatus ? 'Update' : 'Submit'}
                    </Button>
                  </div>
                </>
              );
            }}
          </Formik>
        </Modal>
        <Modal
          title={'Commission slab'}
          visible={isCommissionSlabVisible}
          onCancel={() => setIsCommissionSlabVisible(false)}
          className="supplier-modal"
          destroyOnClose
          footer={null}>
          <div>
            <div className="flex justify-between">
              <div>Greige Cotton</div>
              <div>{`${cottonValue}%`}</div>
            </div>
            <div className="flex justify-between mt-12">
              <div>Greige Rayon</div>
              <div>{`${rayonValue}%`}</div>
            </div>
            <div className="footer">
              <Button
                key="back"
                onClick={() => setIsCommissionSlabVisible(false)}
                className="clear">
                Close
              </Button>
              <Button
                key="submit"
                type="primary"
                role="submit"
                className="apply"
                onClick={() => setIsModalVisible(true)}>
                Edit
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  mills: props.users || state.user.mills,
  millDetails: state.user.millDetails,
  lfUsers: state.auth.lfUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getMills: () => dispatch(getMills()),
  showErrorMessage: (message) => dispatch(flash({ message })),
  getMillDetails: (id) => dispatch(getMillDetails(id)),
  changeMillStatus: (data) => dispatch(changeMillStatus(data)),
  changeLCVStatus: (data) => dispatch(changeLCVStatus(data)),
  deactivateMill: (data) => dispatch(deactivateMill(data)),
  changeDirectInvoiceStatus: (data) => dispatch(changeDirectInvoiceStatus(data)),
  getLocofastUsers: (data) => dispatch(getLocofastUsersAction(data)),
  updateAllocatedSM: (data) => dispatch(updateAllocatedSMAction(data)),
  updateODA: (data) => dispatch(updateOdaStatus(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditMill);
